import i18n from "@/locales";
import moment from "moment-timezone";

export const timeAgoPrecisely = (date: string) => {
  const isChinese = i18n.global.locale.value === "zh-CN";
  let time;
  const type = getDateDiff(date);
  //1：新消息，2：当天消息,3：昨天消息，4：今年消息，5：其他消息
  if (type == 1) {
    time = ""; //新消息，不显示时间，但是要显示"以下为最新消息"
  } else if (type == 2) {
    time = moment(date).format(`[${isChinese ? "今天" : "Today"}] H:mm`); //当天消息，显示：10:22
  } else if (type == 3) {
    time = moment(date).format(`[${isChinese ? "昨天" : "Yesterday"}] H:mm`); //昨天消息，显示：昨天 20:41
  } else if (type == 4) {
    time = moment(date);
    if (isChinese) {
      time = time.format("M月D日 AH:mm");
      time = time.replace("AM", "上午").replace("PM", "下午");
    } else {
      time = time.format("MMM D, HH:mm");
    }
  } else if (type == 5) {
    time = moment(date);
    if (isChinese) {
      time = time.format("YYYY年M月D日 AH:mm");
      time = time.replace("AM", "上午").replace("PM", "下午");
    } else {
      time = time.format("YYYY MMM D, HH:mm");
    }
  }
  return {
    time: time,
    type: type,
  };
};

function getDateDiff(date: string) {
  const nowDate = moment(new Date()); //当前时间
  const oldDate = moment(new Date(date)); //参数时间
  let result;
  if (nowDate.year() - oldDate.year() >= 1) {
    result = 5;
  } else if (
    nowDate.month() - oldDate.month() >= 1 ||
    nowDate.date() - oldDate.date() >= 2
  ) {
    result = 4;
  } else if (nowDate.date() - oldDate.date() >= 1) {
    result = 3;
  } else {
    result = 2;
  }
  return result;
}
